"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UPLOADING_STATUSES = void 0;
var UPLOADING_STATUSES;
(function (UPLOADING_STATUSES) {
    UPLOADING_STATUSES["WAITING"] = "WAITING";
    UPLOADING_STATUSES["UPLOADING"] = "UPLOADING";
    UPLOADING_STATUSES["PROCESSING"] = "PROCESSING";
    UPLOADING_STATUSES["SUCCEEDED"] = "SUCCEEDED";
    UPLOADING_STATUSES["FAILED"] = "FAILED";
})(UPLOADING_STATUSES = exports.UPLOADING_STATUSES || (exports.UPLOADING_STATUSES = {}));
//# sourceMappingURL=uploading-statuses.js.map